import '@/js/common/plugins/polyfill';
import 'jquery-validation';
import '@travelata-libs/ui-kit/dist/sideEffects.js';
import '@travelata-libs/ui-kit/dist/index.css';
import '@travelata-libs/ui-shared/dist/index.css';
import 'jquery-validation/dist/localization/messages_ru';

import addTravelataClassTheme from '@/js/common/Service/addTravelataClassTheme';
import '@/css/desktop/layout.scss';

import '@/js/common/Domain/Service/disableConsole';
import '@/js/common/plugins/jquery-ui';
import '@/js/common/plugins/logger';
import '@/js/common/Domain/Service/tracking/trackingUserVisit';
import '@/js/common/Domain/Service/tracking/trackingCoreWebVitals';
import '@/js/common/Domain/Service/mixins/mixins';
import '@/js/common/Domain/Model/ExtendEpoxyView';
import '@/js/common/Domain/Model/BackboneMapState';
import '@/js/desktop/plugins/jquery.serialize-object.min';
import './common';
import { globalTrackingErrorsVue, useVueTeleport } from '@app/lib';
import Vue from 'vue';
import CookieConsentPopup from '@ve/components/cookieConsent/CookieConsentPopup.vue';
import DroppedOrderBanner from '@ve/components/droppedOrderBanner/common/DroppedOrderBanner.vue';
import setTbankAnalyticsConditionally from "@/js/common/Domain/Service/tracking/setTbankAnalyticsConditionally";


globalTrackingErrorsVue();
addTravelataClassTheme();
useVueTeleport();
setTbankAnalyticsConditionally();

(function initGlobalBanners() {
  const mountNode = document.createElement('div');
  document.body.append(mountNode);
  new Vue({
    render: (h) => h('div', { attrs: { class: 'global-banners' } }, [
      h(CookieConsentPopup),
      h(DroppedOrderBanner, { props: { hotelContentTitle: 'Мы сохранили ваш тур' } }),
    ]),
  }).$mount(mountNode);
})();
